import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DiscountReset, DiscountValid } from '../../../actions/discount';
import { SetDeparture, SetPrices, setTripUpgrade } from '../../../actions/currentBooking';
import { FetchUpgrades } from '../../../actions/upgrades';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _uniqBy from 'lodash/uniqBy';
import Spinner from '../../shared/spinner';
import dayjs from 'dayjs';
import DayPicker from 'react-day-picker';
import _filter from 'lodash/filter';
import { upgradeQueryExist } from '../../../helpers/upgradesHelper';

class Calender extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      selectedDay:null,
      activeDay:"",
      minDate:"",
      maxDate:"",
      currentDate:"",
      enabledDateOriginal:[],
      enabledDates:[],
      enabledPrice:[],
      selectdropdownValue:"",
      selectdropdownMonths:[],
      duration:0,
      months:["January", "February", "March","April","May","June","July","August","September","October","November","December"],
      priceAdult:[],
      availableDates:true,
      isYearOpen:false,
      calendarReady:false,
      availabileUnits:[]
    }

    this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }

  componentDidMount(){
    this.props.SetDeparture("");
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){
    try{
      if(e.target.offsetParent.className !== "filterDropdown basket" && e.target.offsetParent.className !== "calender"){
        if(this.state.isYearOpen) this.setState({isYearOpen: false});
      }
    }catch(e){}

  }

  monthSelectHelper(data){
    if (data.length > 0) {
      let uniqueMonth = _uniqBy(data, (item) => {
        return dayjs(item.departure_date).format("YYYY-MM")
      });
      let monthMap = _map(uniqueMonth, (item) => {
        return dayjs(item.departure_date).format('MMMM') + " " + dayjs(item.departure_date).format('YYYY');
      });
      return monthMap;
    }else{
      return [dayjs().format('MMMM') + " " + dayjs().format('YYYY')];
    }
  }

  durationRemove(){
      let durationClass = document.querySelectorAll('[data-duration]');
      for(let i = 0; i < durationClass.length; i++){
        durationClass[i].setAttribute('data-duration', '');
      }
  }

  durationHelper(durationDays){

      // 1. Check if duration-calender class exist and remove all classes.
      // 2. Iterate through the durationDays array and add the class 'duration'

      this.durationRemove();

      for (let i = 0; i < durationDays.length; i++) {
          let daysAvailable = document.querySelectorAll('div[aria-label="'+durationDays[i]+'"]');
          if (daysAvailable.length > 0) {
                daysAvailable[0].setAttribute('data-duration', 'duration-calender');

              if(i === durationDays.length - 1){
                daysAvailable[0].setAttribute('data-duration', 'duration-calender-last');
              }
          }
      }

  }

  durationDays(departureDate, duration, calenderStr){

      let tempArr = [];

      // Populate temp array of duration days
      for(let i=1; i < duration; i++){
          if(calenderStr){
              let new_date = dayjs(dayjs(departureDate).toDate(), "YYYY-MM-DD").add(i, 'days').format("YYYY-MM-DD");
              let calender_str = "calendar-day-" + new_date;
              tempArr.push(calender_str);
          }else{
              let new_date = dayjs(dayjs(departureDate).toDate(), "YYYY-MM-DD").add(i, 'days').format('ddd MMM DD YYYY');
              tempArr.push(new_date);
          }
      }
      
      return tempArr;
  }

  durationReselect(){
    //retain duration highlight on month or year change
    if(this.state.selectedDay !== ""){
      if(this.state.selectdropdownValue === dayjs(this.state.selectedDay).format('MMMM YYYY')){
        setTimeout(() => {
          if(this.props.product.header.type !== "hoho" && this.props.product.header.tour_id !== "DAE"){
            this.durationHelper(this.durationDays(this.state.selectedDay, this.state.duration, false));
          }
        },10);
      }
    }
  }


  componentDidUpdate(prevProps, prevState) {


    if(this.props.capacity !== prevProps.capacity){


       //Populate calender tour dates
       let capacityMod = _filter(this.props.capacity.data);
       let toursDates = _map(capacityMod, "departure_date");
       let tourDateMod = _map(toursDates, (n) =>{ return dayjs(n).toDate() });
       let tourPriceAdult = _map(this.props.capacity.data, "price_adult");
       let tourPriceAdultMod = _map(tourPriceAdult, (n) =>{ return this.props.currency.currency_mask.charAt(0) + n });
       let availabileUnits = _map(capacityMod, (n) => { return n.avaiable = (n.units > 0 ) ? true : false; });
       let capacityUnits = _map(capacityMod, (n) => { return n.units });

       
       this.setState({
         minDate:tourDateMod[0],
         maxDate:tourDateMod[tourDateMod.length-1],
         currentDate:tourDateMod[0],
         enabledDateOriginal:toursDates,
         enabledDates:tourDateMod,
         enabledPrice:tourPriceAdultMod,
         selectdropdownMonths:this.monthSelectHelper(capacityMod), //populate avaiable months for calender dropdown and show current calender months for tours with no dates
         duration:this.props.capacity.header.duration, // (Some duration missing from capacity call [header-duration])
         priceAdult:tourPriceAdult,
         availableDates:true,
         availabileUnits:availabileUnits,
         capacityUnits:capacityUnits
       }, () => {

         //avoids error message FOUC
        this.setState({
          availableDates:(tourDateMod && tourDateMod.length === 0) ? false : true,
          calendarReady:true
        });

         //check routes for routeParams dates
         this.checkRouteParamDate(this.props.routeParams, toursDates);

       });


    }

    //show/hide available days depending on pax units - when selected on dates check units
    if(this.props.paxNumber !== prevProps.paxNumber){
      if(this.state.activeDay !== ""){
        let selectedDay = dayjs(this.state.selectedDay).format('YYYY-MM-DD');
        let index = this.state.enabledDateOriginal.indexOf(selectedDay);
        let capacityMod = _filter(this.props.capacity.data, (o) => { return o.departure_date === selectedDay && o.units >= this.props.paxNumber });
        let newAvailbleUnit = this.state.availabileUnits.slice();

        if(capacityMod.length === 0){
          newAvailbleUnit[index] = false;
          this.setState({availabileUnits:newAvailbleUnit});
        }else{
          newAvailbleUnit[index] = true;
          this.setState({availabileUnits:newAvailbleUnit});
        }
      }
    }

  }

  checkRouteParamDate(routeDate, availableDates){

    // Check current route parameter date exist from fetched capacity available dates
    // - show calender date pre-selected if available
      if(routeDate.year !== undefined && routeDate.month !== undefined && routeDate.day !== undefined){
        const routeStr = routeDate.year + "-" + routeDate.month + "-" + routeDate.day;
        const isAvailable = _includes(availableDates, routeStr );


        if(isAvailable){
          const day = dayjs(routeStr).toDate();
          const selectedDay = dayjs(day).format('YYYY-MM-DD');
          const index = this.state.enabledDateOriginal.indexOf(selectedDay);
          const { SetDeparture, SetPrices } = this.props;
          
          this.setState({
            selectedDay:day,
            activeDay:selectedDay,
            currentDate:day
          }, () => {
            //set departure
            SetDeparture(selectedDay);

            //highlight duration dates
            this.durationHelper(this.durationDays(selectedDay, this.state.duration, false));

            //set prices
            SetPrices({"price_adult":this.state.priceAdult[index]});
          });



        }
      }
  }

  handleDayClick = (day, { selected }) => {

    const selectedDay = dayjs(day).format('YYYY-MM-DD');
    const isAvailable = _includes(this.state.enabledDateOriginal, selectedDay );
    const index = this.state.enabledDateOriginal.indexOf(selectedDay);
    const notSoldout = this.state.availabileUnits[index];
    const { SetDeparture, SetPrices } = this.props;

    if(!notSoldout) return;

    this.setState({
      selectedDay: selected ? undefined : day
    });

    if(isAvailable && notSoldout){

      if(this.state.activeDay !== selectedDay){

        this.setState({activeDay:selectedDay})

        //set departure
        SetDeparture(selectedDay);

        //highlight duration dates - except hoho and Asia unlimited
        if(this.props.product.header.type !== "hoho" && this.props.product.header.tour_id !== "DAE"){
          this.durationHelper(this.durationDays(selectedDay, this.state.duration, false));
        }

        //set prices
        SetPrices({"price_adult":this.state.priceAdult[index]});
        
   
        //check upgrade capacity
        if(upgradeQueryExist()){
          this.props.FetchUpgrades(this.props.product.header.tour_id, this.props.currency.iso_currency_code, selectedDay).then(() => {
            if(!this.props.upgradesLoading){
              this.props.setTripUpgrade(this.props.upgrades);
              //this.props.DiscountValid(true);
            }
          });
        }
          


        //promo code - reset discount if non valid date is selected
       if(this.props.currentBooking.promo_code !== "" && this.props.discount.valid){
         this.props.DiscountReset();
       }

  
      }else{
        this.setState({activeDay:""})
        SetDeparture("");
        this.durationRemove();
      }
    }
    else{
      this.setState({activeDay:""})
      SetDeparture("");
      this.durationRemove();
    }

  };

  handleMonthClick = (day) => {

    this.setState({
      selectdropdownValue:dayjs(day).format('MMMM YYYY'),
      currentDate:dayjs(day).toDate()
    }, () => {
      this.durationReselect();
    });
  }
  
  renderPriceDay(day){
    let dayMod = dayjs(day).format('YYYY-MM-DD');
    let index = this.state.enabledDateOriginal.indexOf(dayMod);

    if(index !== - 1){
      return this.state.availabileUnits[index] ? this.state.enabledPrice[index] : "Sold out";
    }else{
      return <span>&nbsp;</span>;
    }
  }

  renderCalenderPriceClass(day){
    let dayMod = dayjs(day).format('YYYY-MM-DD');
    let index = this.state.enabledDateOriginal.indexOf(dayMod);

    if(index !== - 1){
      return this.state.availabileUnits[index] ? "" : "invalid";
    }else{
      return "";
    }
  }

  renderUnitsLeft(day){
    //render the number of units left if under 10
    let dayMod = dayjs(day).format('YYYY-MM-DD');
    let index = this.state.enabledDateOriginal.indexOf(dayMod);

    if(index !== - 1){
      if(this.state.availabileUnits[index]){
        if(this.state.capacityUnits[index] > 0 && this.state.capacityUnits[index] < 10){
          return this.state.capacityUnits[index] + ' left';
        }else{
          return <span style={{display:'none'}}>
            {this.state.capacityUnits[index] + ' left'}
          </span>;
        }
      }
    }else{
      return <span>&nbsp;</span>;
    }
  }

  renderDay(day){
    const date = day.getDate();

    return(
      <div>
        {date}
        <div className={`calender-price ${this.renderCalenderPriceClass(day)}`}>
          {this.renderPriceDay(day)}
        </div>

        <div className="units-left">
          {this.renderUnitsLeft(day)}
        </div>

      </div>
    )
  }

  handleYearMonthChange = (e, value) => {

    const _month = value.split(" ")[0];
    const _year = value.split(" ")[1];
    const _monthIndex = this.state.months.indexOf(_month);

    // Set the current drop down menu value and current calender date
    this.setState({
      selectdropdownValue:value,
      currentDate:new Date(_year, _monthIndex),
      isYearOpen:false,
      activeDay:""
    }, () => {
      this.durationReselect();
    });

  }

  onYearClick(e){
    e.preventDefault();
    this.setState({isYearOpen:!this.state.isYearOpen});
  }

  YearMonthForm(){
    const { isYearOpen, selectdropdownMonths } = this.state;
    const currentMonth = dayjs(this.state.currentDate).format('MMMM YYYY');

    return (
      <form className="DayPicker-Caption">
         <div className="row">
          <div className="column small-6 medium-4 large-3 small-centered">
            <div className="filterDropdown basket">
              <div className="row">
                <div className="columns small-12">
                  <a onClick={ e => this.onYearClick(e) } className="filterDropdown-btn calender">
                  {currentMonth}
                  <i className={`fa fa-chevron-down ${isYearOpen ? 'active' : ''}`} aria-hidden="true"></i>
                  </a>
                </div>
                <div className="columns small-12 end">
                  <ul className="calender" style={{display: isYearOpen ? 'block':'none' }}>
                    {
                      selectdropdownMonths.map((value, index) => {
                        return (
                          <li
                            value={value}
                            onClick={e => this.handleYearMonthChange(e, value)}
                            key={index}>{value}
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>

         </div>
        </div>

      </form>
    )
  }


  render(){

    const { minDate, maxDate, enabledDates, selectedDay, currentDate, availableDates, calendarReady } = this.state;
    const { product:{header}, capacityLoading, currentBooking:{tour_id, city_id}, errorMessages } = this.props;

    if(header.type === undefined){
      return <Spinner text={(header.type === "fixed" || header.type === undefined ) ? "Checking prices and availability..." : "Please select Hop-on Hop-off tour..."} loadClass="loading-spinner" />
    }
    if(header.type === "hoho" && (tour_id !== "" || city_id !== "0") && capacityLoading){
      return ( <Spinner text="Checking prices and availability..." loadClass="loading-spinner" /> );
    }
    if(header.type === "hoho" && city_id === "0"){
      return ( <Spinner text="Please select pass and start city." loadClass="loading-spinner no-spinner" /> );
    }
    if(header.type === "flexi" && (tour_id !== "" || city_id !== "0") && capacityLoading){
      return ( <Spinner text="Checking prices and availability..." loadClass="loading-spinner" /> );
    }
    if(header.type === "flexi" && city_id === "0"){
      return ( <Spinner text="Please select pass and start city." loadClass="loading-spinner no-spinner" /> );
    }
    else{

      if(!calendarReady){
        return ( <Spinner text="Checking prices and availability..." loadClass="loading-spinner" /> );
      }else{
        return (
          <React.Fragment>
          <p className="form-error calendar" style={{'display':(availableDates) ? 'none':'block' }}>{errorMessages['PRODUCT_CAPACITY']}</p>
          <DayPicker
            className={ (availableDates) ? '' : 'error'}
            showOutsideDays
            firstDayOfWeek={1}
            numberOfMonths={1}
            fromMonth={(minDate || null )}
            toMonth={(maxDate || null )}
            month={(currentDate || null)}
            value={selectedDay}
            selectedDays={selectedDay}
            onDayClick={this.handleDayClick}
            onMonthChange={this.handleMonthClick}
            canChangeMonth={true}
            modifiers={{
              available:enabledDates
            }}
            renderDay={this.renderDay.bind(this)}
            captionElement={this.YearMonthForm.bind(this)}
            weekdaysShort={['SUN', 'MON', 'TUES', 'WED', 'THU', 'FRI', 'SAT']}
          />
          </React.Fragment>
        )
      }
    }

  }

}


function mapStateToProps(state){
  return{
    capacity:state.capacity.data,
    currency:state.currency,
    product:state.product,
    paxNumber:state.currentBooking.passengers.length,
    capacityLoading:state.capacity.isFetching,
    currentBooking:state.currentBooking.trips[0],
    errorMessages:state.errorMessages,
    discount:state.discount,
    upgrades:state.upgrades.data,
    upgradesLoading:state.upgrades.isFetching
  }
}


function mapDispatchToProps(dispatch){
  return bindActionCreators({
    SetDeparture,
    SetPrices,
    DiscountReset,
    DiscountValid,
    FetchUpgrades,
    setTripUpgrade
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Calender);



// WEBPACK FOOTER //
// ./src/components/basket/components/calender.js